import Head from "next/head";
import Script from "next/script";

import s from "@/styles/Home.module.css";
import { ComponentJourneyWrapper } from "@/components/ui/Screens";
import { getPageContentBySlug } from "@/stores/apis/apiSettings";
import { WEBSITE_CONTENT_SLUGS } from "@/config/constants";

export async function getServerSideProps({ query = {} }) {
	const { preview = false } = query;
	let pageContent = null;
	let data = await getPageContentBySlug(WEBSITE_CONTENT_SLUGS.JOURNEY, preview);
	if (data.success) pageContent = data.data;
	return {
		props: { pageContent: pageContent },
	};
}

export default function Journey({ pageContent = {} }) {
	return (
		<div className={s.container}>
			<Head>
				<title>
					{pageContent?.content?.seo?.seo_title || "Our Story: Royal Air's 60-Year Legacy of Aviation"}
				</title>
				<link rel="icon" href="/favicon.ico" />
				<link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
				<link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
				<link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
				<link rel="manifest" href="/site.webmanifest" />
				<link rel="mask-icon" href="/safari-pinned-tab.svg" color="#ffb11a" />
				<meta name="msapplication-TileColor" content="#da532c" />
				<meta name="theme-color" content="#ffffff" />
				<meta
					name="description"
					content={
						pageContent?.content?.seo?.seo_description ||
						"Discover Royal Air's journey from a garage startup to a fleet of 50+ aircraft and 100+ staff, offering jet charter, freight, and Jet 1 Suites."
					}
				></meta>
				<meta
					property="og:image"
					content={
						pageContent?.content?.seo?.seo_og_image ||
						"https://royal-air.s3.us-west-2.amazonaws.com/pub/royal-air-charter.jpg"
					}
				></meta>
				<meta
					itemProp="thumbnailUrl"
					content={
						pageContent?.content?.seo?.seo_og_image ||
						"https://royal-air.s3.us-west-2.amazonaws.com/pub/royal-air-charter.jpg"
					}
				/>
				<meta
					name="twitter:image"
					content={
						pageContent?.content?.seo?.seo_og_image ||
						"https://royal-air.s3.us-west-2.amazonaws.com/pub/royal-air-charter.jpg"
					}
				></meta>
			</Head>
			<Script src="https://www.googletagmanager.com/gtag/js?id=G-VCNS22HF5D" />
			<Script id="google-analytics">
				{`
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());

                    gtag('config', 'G-VCNS22HF5D');
                `}
			</Script>

			<main style={{ padding: 0, width: "100%" }}>
				{pageContent?.content && <ComponentJourneyWrapper pageContent={pageContent} />}
			</main>
		</div>
	);
}
